import SearchIcon from '@mui/icons-material/Search';
import {Container, Stack, TextField, Typography} from '@mui/material';
import {useQuery} from '@tanstack/react-query';
import React, {useState} from 'react';
import {getFeeds, getSubscriptions} from '../api.js';
import Spinner from '../components/Spinner.js';
import SubscriptionList from '../components/SubscriptionList.jsx';

const Overview = () => {
  const [filter, setFilter] = useState('');
  // TODO: Handle pagination
  const subscriptionsQuery = useQuery({
    queryKey: ['subscriptions'],
    queryFn: () => getSubscriptions(),
  });
  const feedsQuery = useQuery({queryKey: ['feeds'], queryFn: () => getFeeds()});

  if (subscriptionsQuery.isLoading || feedsQuery.isLoading) {
    return <Spinner />;
  }

  return (
    <Container
      maxWidth="xl"
      sx={{
        // flex: 1,
        flexDirection: 'column',
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: 2,
          marginBottom: 1,
        }}
      >
        <Typography variant="h4">My subscriptions</Typography>
        <TextField
          variant="standard"
          sx={{paddingRight: 0.5}}
          value={filter}
          onChange={evt => setFilter(evt.target.value)}
          slotProps={{
            input: {
              startAdornment: <SearchIcon sx={{color: '#738486'}} />,
              placeholder: 'Search',
            },
          }}
        />
      </Stack>

      <SubscriptionList
        style={{flex: 1}}
        filter={filter}
        subscriptions={subscriptionsQuery.data}
        feeds={feedsQuery.data}
      />
    </Container>
  );
};

export default Overview;
